module.exports = __webpack_public_path__ + "static/media/download.8f722a0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/download.svg
// module id = 481
// module chunks = 0